import React, { useEffect, useState } from "react";

const PrivacyPage = () => {
  const [page, setPage] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    fetch("https://parmazing.net/wp-json/wp/v2/pages?slug=privacy-policy")
      .then((res) => {
        if (!res.ok) throw new Error(`HTTP ${res.status}`);
        return res.json();
      })
      .then((data) => {
        if (data && data.length > 0) {
          setPage(data[0]);
        } else {
          setError("Page not found");
        }
      })
      .catch((err) => {
        console.error("WP API error:", err);
        setError("Failed to load page");
      })
      .finally(() => setLoading(false));
  }, []);

  if (loading) return <div className="p-10 text-center">Loading…</div>;
  if (error) return <div className="p-10 text-center text-red-600">{error}</div>;

  return (
    <div className="relative min-h-screen flex flex-col items-center justify-start px-6 md:px-12 pt-32 pb-20 bg-gray-50">
      {/* Background Accents */}
      <div className="absolute inset-0 overflow-hidden">
        <div className="w-96 h-96 bg-yellow-200 opacity-20 rounded-full absolute top-10 left-10 transform -translate-x-1/3 -translate-y-1/3"></div>
        <div className="w-72 h-72 bg-yellow-100 opacity-20 rounded-full absolute bottom-10 right-10 transform translate-x-1/3 translate-y-1/3"></div>
      </div>

      <header className="text-center max-w-4xl">
        <h1
          className="text-4xl font-extrabold text-gray-900 leading-tight"
          dangerouslySetInnerHTML={{ __html: page.title.rendered }}
        />
        <div className="w-16 h-1 bg-yellow-500 mx-auto mt-3 rounded-full"></div>
      </header>

      <div
        className="prose prose-lg mt-10 bg-white p-10 rounded-2xl shadow-md max-w-4xl w-full"
        dangerouslySetInnerHTML={{ __html: page.content.rendered }}
      />
    </div>
  );
};

export default PrivacyPage;
